<template>
  <star-condition-layout
    ref="starCondition"
    :onSearch="handleSearch"
    :onReset="reset"
    :loading="loading"
  >
    <star-condition-cell label="站点ID">
      <a-input v-model="searchCondition.spiderId" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="站点名称">
      <a-input v-model="searchCondition.spiderName" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="国家">
      <CountrySelect v-model="searchCondition.country" />
    </star-condition-cell>

    <star-condition-cell label="语言">
      <LangSelect v-model="searchCondition.lang" />
    </star-condition-cell>

    <star-condition-cell label="执行状态">
      <a-select v-model="searchCondition.execType" style="width: 100%" allowClear>
        <a-select-option :value="1">运行</a-select-option>
        <a-select-option :value="-1">暂停</a-select-option>
        <a-select-option :value="0">待运行</a-select-option>
      </a-select>
    </star-condition-cell>

    <star-condition-cell label="类别" v-if="tabKey === '2'">
      <a-select v-model="searchCondition.spiderClassId" style="width: 100%" allowClear>
        <a-select-option
          v-for="item in spiderClassOptions"
          :key="item.spiderClassId"
          :value="item.spiderClassId"
          >{{ item.spiderClassName }}
        </a-select-option>
      </a-select>
    </star-condition-cell>

    <star-condition-cell label="类别" v-if="tabKey === '3'">
      <a-select v-model="searchCondition.spiderClassId" style="width: 100%" allowClear>
        <a-select-option
          v-for="item in apiToutiaoclassOptions"
          :key="item.spiderClassId"
          :value="item.spiderClassId"
          >{{ item.spiderClassName }}
        </a-select-option>
      </a-select>
    </star-condition-cell>
  </star-condition-layout>
</template>

<script>
const Wemedia_Type_List = ['weibo', 'twitter', 'facebook', 'youtube', 'vk', 'tg', 'ins']

import CountrySelect from '@/components/CountrySelect/'
import LangSelect from '@/components/LangSelect/'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent } from '@/utils/request'

export default {
  components: { CountrySelect, LangSelect },
  props: {
    onSearch: {
      type: Function,
      required: true
    },
    tabKey: {
      type: String,
      required: true
    },
    typeSelect: {
      // type: String
    }
  },
  data() {
    return {
      searchCondition: {
        spiderName: '',
        spiderId: '',
        country: undefined,
        execType: undefined,
        spiderClassId: undefined,
        apiSpiderClassId: undefined
      },
      loading: false,

      spiderClassOptions: [],
      defaultSpiderClassId: undefined,

      apiToutiaoclassOptions: [],
      defaultApiTouSpiderClassId: undefined
    }
  },
  watch: {
    searchCondition: {
      handler: function () {
        sessionStorage.setItem('condition', JSON.stringify(this.searchCondition))
      },
      deep: true
    },
    tabKey: {
      handler: function () {
        this.$nextTick(() => {
          // this.searchCondition.spiderClassId = null
        })
      }
      // deep: true
    }
  },
  created() {
    this.searchCondition.apiSpiderClassId = this.typeSelect
  },
  mounted() {
    this.querySpiderClassInfo()
    let condition = sessionStorage.getItem('condition')
    if (condition) {
      this.searchCondition = JSON.parse(condition)
    }
    // this.onSearch()
  },
  methods: {
    querySpiderClassInfo() {
      querySpiderClassInfoApi()
        .then(onHttpResponseSilent)
        .then((res) => {
          this.spiderClassOptions = res.data.filter((d) => Wemedia_Type_List.includes(d.type))
          this.apiToutiaoclassOptions = res.data.filter((d) =>
            ['api', 'document', 'wechat'].includes(d.type)
          )
          if (
            this.defaultSpiderClassId &&
            this.spiderClassOptions
              .map((option) => option.spiderClassId)
              .includes(this.defaultSpiderClassId)
          ) {
            this.searchCondition.spiderClassId = this.defaultSpiderClassId
          }

          if (
            this.defaultApiTouSpiderClassId &&
            this.apiToutiaoclassOptions
              .map((option) => option.spiderClassId)
              .includes(this.defaultApiTouSpiderClassId)
          ) {
            this.searchCondition.apiSpiderClassId = this.defaultApiTouSpiderClassId
          }
        })
    },
    reset() {
      this.searchCondition = {
        spiderName: '',
        spiderId: '',
        country: undefined,
        execType: undefined,
        spiderClassId: undefined,
        spiderClassType: undefined
      }
      this.handleSearch()
    },
    changeValue() {
      this.searchCondition = {
        ...this.searchCondition,
        spiderClassId: undefined
      }
      // this.searchCondition.spiderClassId = undefined
    },
    async handleSearch() {
      // if (this.typeSelect) {
      //   this.searchCondition.spiderClassId = this.typeSelect
      // }
      let condition = {
        ...this.searchCondition
      }
      if (this.tabKey === '3') {
        condition.spiderClassId = condition.apiSpiderClassId
      }
      delete condition.apiSpiderClassId

      this.loading = true
      await this.onSearch(condition)
      this.loading = false
    },

    preSaveSpiderClassId(spiderClassId) {
      // 外部调用，默认值
      if (this.spiderClassOptions.length) {
        this.searchCondition.spiderClassId = spiderClassId
      } else {
        this.defaultSpiderClassId = spiderClassId
      }
    },

    returnSearch() {
      return this.searchCondition
    },

    preSaveSpiderApiClassId(spiderClassId) {
      if (this.apiToutiaoclassOptions.length) {
        this.searchCondition.apiSpiderClassId = spiderClassId
      } else {
        this.defaultApiTouSpiderClassId = spiderClassId
      }
    },

    open() {
      this.$refs.starCondition.open()
    }
  }
}
</script>
